const accordionButtons = document.querySelectorAll('.accordion-button');

accordionButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    const accordionItem = this.parentNode;
    const isActive = accordionItem.classList.contains('active');

    accordionButtons.forEach(function (btn) {
      btn.parentNode.classList.remove('active');
    });

    if (!isActive) {
      accordionItem.classList.add('active');
    }
  });
});
